import '../styles/main.css';
import './modules/navigation/bottom-navigation.js';
import './modules/navigation/desktop-navigation.js';
import './modules/navigation/mobile-topbar.js';
import './modules/language/language-switcher.js';
import './modules/language/direction-manager.js';
import './modules/theme-toggle/theme-toggle.js';
import './modules/theme-toggle/theme-aware-images.js';
import './modules/filters/content-filters.js';
import './modules/filters/ajax-content-tabs.js';
import './modules/likes/like-store.js';
import './modules/likes/like-buttons.js';
import './modules/newsletter/newsletter-form.js';
import './modules/media/audio-disclosure.js';
import './modules/media/media-controller.js';
import './modules/motion/reduced-motion.js';
import './modules/loader/site-loader.js';
import './modules/logo-animation/logo-writer.js';
import './modules/quotes/copy-quotes.js';
import './modules/comments/comment-form-disclosure.js';
import './modules/sound/sound-engine.js';
import './modules/sound/sound-toggle.js';
import './modules/sound/mobile-design-interactions.js';
import './modules/cursor/desktop-cursor.js';

const markFrontendReady = () => {
  document.documentElement.dataset.abdelmegedFrontend = 'ready';
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', markFrontendReady, { once: true });
} else {
  markFrontendReady();
}
